import { RecordLoader } from "@/components/record/RecordLoader";
import { Roles } from "@/constants/roles";
import { useGetRole } from "@/hooks/useGetRole";
import { lazy, Suspense } from "react";

const AnalistaPage = lazy(() => import("@/pages/entities/analistaPage"));
const ClientPage = lazy(() => import("@/pages/entities/clientPage"));
const DefaultPage = lazy(() => import("@/pages/entities/DefaultPage"));

export const DashboardSelector = () => {
  const { role } = useGetRole();

  return (
    <Suspense fallback={<RecordLoader />}>
      {{
        [Roles.admin]: <AnalistaPage />,
        [Roles.analista]: <AnalistaPage />,
        [Roles.analyst]: <AnalistaPage />,
        [Roles.agente]: <AnalistaPage />,
        [Roles.client]: <ClientPage />,
      }[role] || <DefaultPage />}
    </Suspense>
  );
};

export default DashboardSelector;
